<template>
  <div>
    <ul>
      <li v-for="(value,key) in content" :key="key">{{value}}</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "expandRow",
    props: {
      index:Number,
      template_list:Array
    },
    computed:{
      content: function () {
        return this.template_list[this.index].content.split('\n');
      }
    }
  };
</script>

<style scoped>
  ul{
    list-style-type: none;
  }
  li{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// expandRow.vue?f332eefa